import * as l from "react";
const e = (h) => /* @__PURE__ */ l.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...h
  },
  /* @__PURE__ */ l.createElement(
    "mask",
    {
      id: "UM_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ l.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ l.createElement("g", { mask: "url(#UM_svg__a)" }, /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0h32v24H0V0z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 14.667v2h32v-2H0zM0 18.333v2h32v-2H0zM0 7.333v2h32v-2H0zM0 22v2h32v-2H0zM0 11v2h32v-2H0zM0 0v2h32V0H0zM0 3.667v2h32v-2H0z",
      fill: "#E31D1C"
    }
  ), /* @__PURE__ */ l.createElement("path", { fill: "#2E42A5", d: "M0 0h20v13H0z" }), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.721 2.938l-.726.51.245-.907-.644-.573h.842l.282-.74.331.74h.718l-.564.573.219.906-.703-.509zm4 0l-.726.51.245-.907-.644-.573h.842l.282-.74.331.74h.718l-.564.573.219.906-.703-.509zm3.274.51l.726-.51.703.51-.219-.907.564-.573h-.718l-.33-.74-.283.74h-.842l.644.573-.245.906zm4.726-.51l-.726.51.245-.907-.644-.573h.842l.282-.74.331.74h.718l-.564.573.219.906-.703-.509zM.995 7.448l.726-.51.703.51-.219-.907.564-.573h-.718l-.33-.74-.283.74H.596l.644.573-.245.906zm4.726-.51l-.726.51.245-.907-.644-.573h.842l.282-.74.331.74h.718l-.564.573.219.906-.703-.509zm3.274.51l.726-.51.703.51-.219-.907.564-.573h-.718l-.33-.74-.283.74h-.842l.644.573-.245.906zm4.726-.51l-.726.51.245-.907-.644-.573h.842l.282-.74.331.74h.718l-.564.573.219.906-.703-.509zM.995 11.448l.726-.51.703.51-.219-.907.564-.573h-.718l-.33-.74-.283.74H.596l.644.573-.245.906zm4.726-.51l-.726.51.245-.907-.644-.573h.842l.282-.74.331.74h.718l-.564.573.219.906-.703-.509zm3.274.51l.726-.51.703.51-.219-.907.564-.573h-.718l-.33-.74-.283.74h-.842l.644.573-.245.906zm4.726-.51l-.726.51.245-.907-.644-.573h.842l.282-.74.331.74h.718l-.564.573.219.906-.703-.509zm3.274-7.49l.726-.51.703.51-.219-.907.564-.573h-.718l-.33-.74-.283.74h-.842l.644.573-.245.906zm.726 3.49l-.726.51.245-.907-.644-.573h.842l.282-.74.331.74h.718l-.564.573.219.906-.703-.509zm-.726 4.51l.726-.51.703.51-.219-.907.564-.573h-.718l-.33-.74-.283.74h-.842l.644.573-.245.906zM3.721 4.937l-.726.51.245-.907-.644-.573h.842l.282-.74.331.74h.718l-.564.573.219.906-.703-.509zm3.274.51l.726-.51.703.51-.219-.907.564-.573h-.718l-.33-.74-.283.74h-.842l.644.573-.245.906zm4.726-.51l-.726.51.245-.907-.644-.573h.842l.282-.74.331.74h.718l-.564.573.219.906-.703-.509zm-8.726 4.51l.726-.51.703.51-.219-.907.564-.573h-.718l-.33-.74-.283.74h-.842l.644.573-.245.906zm4.726-.51l-.726.51.245-.907-.644-.573h.842l.282-.74.331.74h.718l-.564.573.219.906-.703-.509zm3.274.51l.726-.51.703.51-.219-.907.564-.573h-.718l-.33-.74-.283.74h-.842l.644.573-.245.906zm4.726-4.51l-.726.51.245-.907-.644-.573h.842l.282-.74.331.74h.718l-.564.573.219.906-.703-.509zm-.726 4.51l.726-.51.703.51-.219-.907.564-.573h-.718l-.33-.74-.283.74h-.842l.644.573-.245.906z",
      fill: "#F7FCFF"
    }
  ))
), m = e;
export {
  m as default
};
